import { ApPoExportPromoDismissalRepository } from './ApPoExportPromoDismissalRepository'

export const apPoExportPromoDismissalRepository =
  new ApPoExportPromoDismissalRepository({
    getStorage: () => window.sessionStorage,
  })
